import { render, staticRenderFns } from "./addMessage.vue?vue&type=template&id=44b649f3&scoped=true"
import script from "./addMessage.vue?vue&type=script&lang=js"
export * from "./addMessage.vue?vue&type=script&lang=js"
import style0 from "./addMessage.vue?vue&type=style&index=0&id=44b649f3&prod&lang=less&scoped=true"
import style1 from "./addMessage.vue?vue&type=style&index=1&id=44b649f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b649f3",
  null
  
)

export default component.exports